import { Button } from "@gs/uiKit/general/Button";
import { useEffect, useState } from "react";
import type { User } from "@gs/core/domain/User/User";
import { wait } from "@gs/core/utils/wait";
import { marketingAnalytics } from "feature/marketingAnalytics/marketingAnalytics";

export const StepSql = (props: {user: User}) => {
  const [_, setS] = useState(1);
  useEffect(() => {
    setS(2);
  }, []);
  const w = (document.querySelector(".gs-unauth_layout-right")! as HTMLDivElement)?.offsetWidth;
  // @ts-ignore
  delete window._gs_sql;

  const iframeSrc = new URL("https://meetings-eu1.hubspot.com/pkaliuzhny/inbound-product?embed=true");
  iframeSrc.searchParams.set("firstname", props.user.first_name);
  iframeSrc.searchParams.set("lastname", props.user.last_name || "");
  iframeSrc.searchParams.set("email", props.user.email);
  iframeSrc.searchParams.set("linkedin_url", props.user.linkedin_url || "");

  useEffect(() => {
    const handleEvent = async (event: MessageEvent) => {
      if (event.data?.eeventName === "meetingBooked" || event.data?.eventName === "meetingBooked" || event.data.meetingBookSucceeded) {
        marketingAnalytics.fireEvent("sign_up_step_demo_booked");
        await wait(5000);
        window.location.reload();
      }
    };
    const script = document.createElement("script");
    script.src = "https://static.hsappstatic.net/MeetingsEmbed/ex/MeetingsEmbedCode.js";
    script.async = true;
    document.body.appendChild(script);

    window.addEventListener("message", handleEvent);
    return () => {
      script.remove();
      window.removeEventListener("message", handleEvent);
    };
  }, []);

  useEffect(() => {
    marketingAnalytics.fireEvent("sign_up_step_book_demo");
  }, []);

  return (
    <div>
      <div className="gs-fs-28 gs-fw-500 gs-mb"> Let's talk about your goals 🚀</div>
      <div className="gs-fs-16 gs-mb-xxl">
        Have specific questions? Want to make sure it’s the right fit?
        Let’s chat — it takes less than 15 minutes.
      </div>

      <div>
        <span className="gs-c-secondary">Not interested yet?</span>
        <Button
          onClick={() => window.location.reload()}
          type="link"
          size="small"
        >
          Skip for now
        </Button>
      </div>

      {w && (
        <div
          style={{
            position: "absolute",
            height: "100vh",
            width: (document.querySelector(".gs-unauth_layout-right")! as HTMLDivElement).offsetWidth,
            left: `calc(100vw - ${w}px`,
            top: 0,
            background: "linear-gradient(41deg, #9CAFFF 0%, #E8EEFF 86.79%)",
            padding: "0 50px",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            flexDirection: "column",
          }}
        >
          <div
            className="gs-w-100p meetings-iframe-container"
            data-src={iframeSrc.href}
          />
        </div>
      )}
    </div>
  );
};

